module.exports = __webpack_public_path__ + "static/img/bg_item3.d7d35c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_item3.png
// module id = Xy3F
// module chunks = 19